import React from 'react'
import './MedicalInfo.css'

function MedicalInfo() {
  return (
    <div>
      
    </div>
  )
}

export default MedicalInfo
